import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

const pillVariantMap = {
  ready: 'success',
  pending: 'warning',
  active: 'success',
  inactive: 'secondary',
  destructive: 'destructive',
}

/**
 * Top-level expandable panel — LMS modal-panel style with chevron toggle.
 */
export function CollapsePanel({
  id,
  title,
  collapsedSummary,
  open,
  onOpenChange,
  pill,
  pillVariant = 'secondary',
  accent = 'default',
  className,
  bodyClassName,
  children,
}) {
  const badgeVariant = pillVariantMap[pillVariant] ?? pillVariant

  return (
    <div
      className={cn(
        'overflow-hidden rounded-lg border border-border bg-card shadow-card',
        accent === 'primary' && 'border-t-4 border-t-primary bg-[#fbfcfe]',
        !open && 'pb-3',
        className,
      )}
    >
      <div
        className={cn(
          'flex items-start justify-between gap-4 px-[18px] py-3.5',
          open && 'border-b border-border',
        )}
      >
        <button
          type="button"
          className="flex min-w-0 flex-1 items-start gap-2.5 text-left"
          onClick={() => onOpenChange(!open)}
          aria-expanded={open}
          aria-controls={id}
        >
          <span className="w-7 shrink-0 text-[1.75rem] font-bold leading-none text-foreground" aria-hidden="true">
            {open ? '▾' : '▸'}
          </span>
          <span className="flex min-w-0 flex-col gap-1">
            <span className="text-base font-bold tracking-tight text-foreground">{title}</span>
            {!open && collapsedSummary ? (
              <span className="block text-sm font-normal text-muted-foreground">
                {collapsedSummary}
              </span>
            ) : null}
          </span>
        </button>
        {pill ? (
          <Badge variant={badgeVariant} className="mt-0.5 shrink-0">
            {pill}
          </Badge>
        ) : null}
      </div>

      {open ? (
        <div id={id} className={cn('px-[18px] py-4', bodyClassName)}>
          {children}
        </div>
      ) : null}
    </div>
  )
}
